import gql from 'graphql-tag'

export const initCustomerFrequencies = gql`
query initCustomerFrequencies($params: CustomerFrequenciesParams!) {
  cashAssist {
    initCustomerFrequencies(params: $params)
  }
}
`

export const getStatisticsData = gql`
query getStatisticsData($requestId: ID!) {
	cashAssist {
		getStatisticsData(requestId: $requestId) {
			status
      progress
			hasNextPage
      data {
				...on CustomerFrequencies {
					dateTime
					interval
					total
					billCount
					totalK
					creditClient
					creditClientCount
					creditClientTotal
				}
			}
    }
  }
}
`
